
































































































































































import Vue from 'vue';
import axios from 'axios';
import { TradingVue, DataCube } from 'trading-vue-js';
import { core } from '../tradeCore';

let inst;

import { Buffer } from 'buffer';
function dataTemplate(tf: number) {
    return JSON.stringify({
        chart: {
            type: window.localStorage.getItem('chartType') || 'Candles',
            indexBased: false,
            data: [],
            tf: tf * 1000,
        },
        onchart: [
            {
                name: 'Candles/Bars',
                type: 'Swap',
                data: [],
                settings: {
                    showLabel: false,
                    track: true,
                    pending: false,
                    pending_type: '',
                },
            },
            {
                name: 'Trades',
                type: 'PerfectTrades',
                data: [],
                settings: {
                    'z-index': 5,
                    inMult: 5,
                    outMult: 10,
                    mult: 1,
                },
            },
            {
                name: 'Trades',
                type: 'BB',
                data: [],
                settings: {
                    'z-index': 5,
                    lineWidth: 0.75,
                    borderColor: '#ffffff',
                    middleColor: '#2cc6c9',
                    showMid: true,
                    backColor: '#2cc6c911',
                },
            },
        ],
    });
}
const timeFrames = [
    { text: 'M1', value: 60 },
    { text: 'M2', value: 120 },
    { text: 'M3', value: 180 },
    { text: 'M5', value: 300 },
    { text: 'M10', value: 600 },
    { text: 'M15', value: 900 },
    { text: 'M30', value: 1800 },
    { text: 'H1', value: 3600 },
    //{ text: 'H2', value: 7200 },
    //{ text: 'H4', value: 14400 },
    //{ text: 'H8', value: 28800 },
    //{ text: 'D1', value: 86400 },
];
function mkTfs() {
    let res = {};
    timeFrames.forEach((el) => {
        res[el.value] = el.text;
    });
    return res;
}
function mkIds() {
    let res = {};
    for (let i = 0; i < timeFrames.length; i++) {
        res[`${timeFrames[i].value}`] = i;
    }
    return res;
}
function mkData() {
    let res = new DataCube(JSON.parse(dataTemplate(60)), { auto_scroll: false, scripts: true, script_depth: 0 });

    return res;
}
function populateData(candles: any) {
    const result = [] as any;
    for (let i = 0; i < candles.length; i++) {
        result.push([
            candles[i]['epoch'] * 1000,
            candles[i]['open'],
            candles[i]['high'],
            candles[i]['low'],
            candles[i]['close'],
            0,
        ]);
    }

    return result;
}
import {
    ALMA,
    Area51,
    ATR,
    ATRp,
    BB,
    BBW,
    CCI,
    CMO,
    COG,
    DHistogram,
    DMI,
    EMA,
    Histogram,
    HMA,
    Ichi,
    Ichimoku,
    KC,
    KCW,
    LongShortTrades,
    MACD,
    Markers,
    MFI,
    MOM,
    PerfectTrades,
    PlotCross,
    Ribbon,
    ROC,
    RSI,
    SAR,
    SMA,
    Stoch,
    SWMA,
    TradesPlus,
    TSI,
    VWMA,
    WilliamsR,
    XOhlcBars,
} from '@/Scripts/Indicators.js';
import Fibo from '@/Scripts/Fibo.js';
import LineTool from '@/Scripts/LineTool.js';
import Swap from '@/Scripts/Swap.js';
import Pline from '@/Scripts/Pline.js';
import { nextTick } from 'vue/types/umd';
import { fetchCandles, createLiveFeed, configuredTickers } from '@/tiingoApi';

let loginFeed: any;
// The login backdrop just needs one liquid pair to draw a chart.
const LOGIN_SYMBOL = configuredTickers()[0];
function getWidth() {
    const el = document.getElementById('card');
    if (el) {
        return el.getBoundingClientRect().width;
    }
    return window.innerWidth;
}
function getHeight() {
    const el = document.getElementById('card');
    if (el) {
        return el.getBoundingClientRect().height;
    }
    return window.innerHeight;
}

export default Vue.extend({
    name: 'Login',
    computed: {
        colors: () => {
            return {
                colorBack: '#202020',
                colorTitle: '#77CEFF',
                colorCU: '#1E88E5',
                colorCD: '#FF3333',
            };
        },
    },
    data: () => ({
        core: core.controller,
        starting: false,
        loaded: false,
        token: '',
        height: getHeight(),
        width: getWidth(),
        datas: mkData(),
        overlays: [
            ALMA,
            Area51,
            ATR,
            ATRp,
            BB,
            BBW,
            CCI,
            CMO,
            COG,
            DHistogram,
            DMI,
            EMA,
            Histogram,
            HMA,
            Ichi,
            Ichimoku,
            KC,
            KCW,
            LongShortTrades,
            MACD,
            Markers,
            MFI,
            MOM,
            PerfectTrades,
            PlotCross,
            Ribbon,
            ROC,
            RSI,
            SAR,
            SMA,
            Stoch,
            SWMA,
            TradesPlus,
            TSI,
            VWMA,
            WilliamsR,
            XOhlcBars,
            Pline,
            Fibo,
            LineTool,
            Swap,
        ],
        locale: 'fr' as string | null,
        hkey: 0,
        validate: false,
        nextStep: false,
        email: '',
        password: '',
        loading: false,
        resetForm: false,
        passwordReset: false,
        resetLoading: false,
        notify: false,
        notifyError: false,
        notificationText: ``,
        notificationTitle: '',
        emailRules: [
            (value: any) => !!value || 'Requise.',
            (value: any) => {
                const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'e-mail invalide.';
            },
        ],
        requiredRules: [(value: any) => !!value || 'Requise.'],
        showPassword: false,
    }),
    beforeMount() {
        this.$emit('login');
        window.localStorage.clear();
        inst = this;
        fetchCandles(LOGIN_SYMBOL, 60, 500, 0)
            .then((candles: any) => {
                inst.datas.merge('chart.data', populateData([...candles]));
                inst.$nextTick(() => {
                    const range = inst.$refs[`chart0`].getRange();
                    const t1 = (range[0] + range[1]) / 2;
                    const t2 = range[1];
                    inst.$nextTick(() => {
                        inst.$refs[`chart0`].setRange(t1, t2);
                        inst.loaded = true;
                    });
                });
            })
            .catch((err: any) => {
                console.error('[tiingo]', err.message);
            });

        loginFeed = createLiveFeed({
            tickers: [LOGIN_SYMBOL],
            granularities: [60],
            onFatal: function (err: any) {
                console.error('[tiingo]', err.message);
            },
            onOhlc: function (data: any) {
                const payload = [
                    data['ohlc']['open_time'] * 1000,
                    Number(data['ohlc']['open']),
                    Number(data['ohlc']['high']),
                    Number(data['ohlc']['low']),
                    Number(data['ohlc']['close']),
                    0,
                ];
                inst.$refs[`chart0`].data.update({
                    candle: payload,
                    //tf: granularity * 1000,
                });
                inst.scrollToLast();
            },
        });
        loginFeed.start();
    },
    mounted() {
        console.log('mounted');
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        if (loginFeed != undefined) {
            loginFeed.stop();
        }
    },
    methods: {
        focusNext(e: number) {
            document.getElementById(`validate-${e}`)?.click();
        },
        onResize(event) {
            this.setSize();
        },
        setSize() {
            this.height = getHeight();
            this.width = getWidth();
        },

        async login() {
            return new Promise((resolve, reject) => {
                try {
                    const id = Date.now().toString(16);
                    const secret = '$2y$10$y0cudLALEw3JrqcIVlNHt.zWIcCj9FByLrBSu2O0hPSC9p4KsHE4q';
                    const token = this.crypt(String(id), secret, '-e');
                    const data = { token: token, id: id, secret: secret, solde: 10000 };
                    this.core
                        .userlogin({ body: { data: JSON.stringify(data) } })

                        .then((res) => {
                            console.log('login #######', res.data);

                            resolve(res.data);
                        })
                        .catch((err) => {
                            const result = JSON.stringify(err);
                            const status = JSON.parse(result);
                            reject(status.status);
                        });
                } catch (error) {
                    reject(error);
                }
            });
        },
        start() {
            this.loading = true;
            this.login().then(
                (res: any) => {
                    console.log('start #######', res.token);
                    console.log('start #######', res.id);
                    window.localStorage.setItem('token', String(res.token));
                    window.localStorage.setItem('id', String(res.id));
                    debugger;
                    this.starting = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.$emit('loggedin');
                        window.location.href = '/';
                    }, 500);
                },
                (rej: any) => {
                    window.localStorage.clear();
                    setTimeout(() => {
                        this.loading = false;
                        window.location.reload();
                    }, 500);
                }
            );
        },
        scrollToLast() {
            /*const len = this.datas.data.chart.data.length;*/
            /*(this.$refs[`chart0`] as any).goto(len + 4.5);*/
        },
        crypt(data: string, key: string, meth: string) {
            let dataOut = '';
            let dataIn;
            let hash;
            if (meth == '-u') {
                dataIn = Buffer.from(data, 'hex');
                hash = Buffer.from(key, 'utf-8');
                let ib = 0;
                let rb = false;
                let iv = -1;
                for (let i = 0; i < dataIn.length; i++) {
                    if (ib == hash.length - 1) {
                        rb = true;
                    }
                    if (ib == 0) {
                        rb = false;
                        iv = iv * -1;
                    }

                    if (dataIn[i] < hash[ib] * iv) {
                        dataIn[i] = 256 - hash[ib] * iv + dataIn[i];
                    } else {
                        dataIn[i] = (dataIn[i] - hash[ib] * iv) % 256;
                    }
                    if (hash.length > 1) {
                        if (!rb) {
                            ib++;
                        } else {
                            ib--;
                        }
                    }
                }
                dataOut = dataIn.toString();
            } else if (meth == '-e') {
                dataIn = Buffer.from(data, 'utf-8');
                hash = Buffer.from(key, 'utf-8');
                let ib = 0;
                let rb = false;
                let iv = -1;
                for (let i = 0; i < dataIn.length; i++) {
                    if (ib == hash.length - 1) {
                        rb = true;
                    }
                    if (ib == 0) {
                        rb = false;
                        iv = iv * -1;
                    }
                    if (dataIn[i] + hash[ib] * iv < 0) {
                        dataIn[i] = dataIn[i] + hash[ib] * iv + 256;
                    } else {
                        dataIn[i] = (dataIn[i] + hash[ib] * iv) % 256;
                    }

                    if (hash.length > 1) {
                        if (!rb) {
                            ib++;
                        } else {
                            ib--;
                        }
                    }
                }
                dataOut = dataIn.toString('hex');
            }
            console.log(dataOut);
            return dataOut.toUpperCase();
        },
    },
    components: {
        TradingVue,
    },
});
